import { EmptyStatePropsActions } from '../../molecules/EmptyState';
import { PaginationPropsMicrocopy } from '../../molecules/Pagination';
import { ReportReviewModalData } from '../ReportReviewModal';
import {
  UserProductReviewPropsData,
  UserProductReviewPropsMicrocopy,
} from '../UserProductReview';
import {
  ReviewFormData,
  WriteReviewModalPropsActions,
  WriteReviewModalPropsData,
  WriteReviewModalPropsMicrocopy,
} from '../WriteReviewModal';

export const enum ProductReviewFilterValues {
  DEFAULT = '',
  ONE_STAR = '1',
  TWO_STARS = '2',
  THREE_STARS = '3',
  FOUR_STARS = '4',
  FIVE_STARS = '5',
}

export type ProductReviewFilterOptions = {
  label: string;
  value: ProductReviewFilterValues;
};

export const enum ProductReviewSortByValues {
  MOST_RECENT = 'most-recent',
  TOP_RATED = 'top-rated',
}

export type ProductReviewSortByOptions = {
  label: string;
  value: ProductReviewSortByValues;
};

export type ProductReviewsPropsMicrocopy = UserProductReviewPropsMicrocopy & {
  reviews: string;
  filters: string;
  sortBy: string;
  filterOptions: string[];
  sortOptions: string[];
  results: string;
  rating: string;
  mostRecent: string;
  helpfulness: string;
  pagination: PaginationPropsMicrocopy;
  emptyState?: {
    title: string;
    description: string;
    cta?: string;
    writeReview: WriteReviewModalPropsMicrocopy;
  };
};

export type ProductReviewsPropsData = {
  reviews: UserProductReviewPropsData[];
  start: number;
  end: number;
  total: number;
  currentPage: number;
  totalPages: number;
  writeReviewModal: WriteReviewModalPropsData;
};

export type ProductReviewsPropsActions = WriteReviewModalPropsActions &
  EmptyStatePropsActions & {
    onHelpfulVotesReview: (reviewId: string) => void;
    onEditReview: (reviewId: string, formData: ReviewFormData) => Promise<void>;
    onDeleteReview: (reviewId: string) => void;
    onHelpfulVotesReply: (replyId: string) => void;
    onEditReply: (replyId: string) => void;
    onDeleteReply: (replyId: string) => void;
    onSubmitReply: (reply: string, replyId?: string) => void;
    onFilter: (filter: string) => void;
    onSort: (sort: string) => void;
    onPageChange: (page: number) => void;
    onSubmitReport: (data: ReportReviewModalData) => void;
    onClickEmptyStateCta?: () => void;
  };

export type ProductReviewsPropsDataWithMicrocopy = {
  microcopy: ProductReviewsPropsMicrocopy;
} & ProductReviewsPropsData;

export type ProductReviewsProps = ProductReviewsPropsDataWithMicrocopy &
  ProductReviewsPropsActions & {
    reviewsOnLoad: UserProductReviewPropsData[];
    className?: string;
  };
